import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path) => {
    return location.pathname === path;
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled 
        ? 'bg-white shadow-lg backdrop-blur-sm' 
        : 'bg-white/90 backdrop-blur-sm'
    }`}>
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3" onClick={closeMobileMenu}>
            <div className="w-12 h-12 flex items-center justify-center overflow-hidden rounded-xl">
              <img src="/logo.png" alt="Quiz Test Logo" className="w-full h-full object-contain" />
            </div>
            <div className="flex flex-col">
              <span className="text-xl font-bold text-gray-800 leading-none">QuizTest</span>
              <span className="text-[10px] font-medium text-blue-600 uppercase tracking-tighter mt-1">TỔ HỢP TEST TÂM LÝ</span>
            </div>
          </Link>

          {/* Navigation */}
          <nav className="hidden md:flex space-x-8">
            <Link
              to="/"
              className={`font-medium transition-colors ${
                isActive('/')
                  ? 'text-blue-600 border-b-2 border-blue-600 pb-1'
                  : 'text-gray-600 hover:text-blue-600'
              }`}
            >
              Trang chủ
            </Link>
            <Link
              to="/about"
              className={`font-medium transition-colors ${
                isActive('/about')
                  ? 'text-blue-600 border-b-2 border-blue-600 pb-1'
                  : 'text-gray-600 hover:text-blue-600'
              }`}
            >
              Giới thiệu
            </Link>
            <Link
              to="/test-mbti"
              className={`font-medium transition-colors ${
                isActive('/test-mbti')
                  ? 'text-blue-600 border-b-2 border-blue-600 pb-1'
                  : 'text-gray-600 hover:text-blue-600'
              }`}
            >
              Test MBTI
            </Link>
            <Link
              to="/test-iq"
              className={`font-medium transition-colors ${
                isActive('/test-iq')
                  ? 'text-blue-600 border-b-2 border-blue-600 pb-1'
                  : 'text-gray-600 hover:text-blue-600'
              }`}
            >
              Test IQ
            </Link>
            <Link
              to="/test-eq"
              className={`font-medium transition-colors ${
                isActive('/test-eq')
                  ? 'text-blue-600 border-b-2 border-blue-600 pb-1'
                  : 'text-gray-600 hover:text-blue-600'
              }`}
            >
              Test EQ
            </Link>
            <Link
              to="/test-disc"
              className={`font-medium transition-colors ${
                isActive('/test-disc')
                  ? 'text-blue-600 border-b-2 border-blue-600 pb-1'
                  : 'text-gray-600 hover:text-blue-600'
              }`}
            >
              Test DISC
            </Link>
            <Link
              to="/holland-codes"
              className={`font-medium transition-colors ${
                isActive('/holland-codes')
                  ? 'text-blue-600 border-b-2 border-blue-600 pb-1'
                  : 'text-gray-600 hover:text-blue-600'
              }`}
            >
              Holland Codes
            </Link>
            <Link
              to="/contact"
              className={`font-medium transition-colors ${
                isActive('/contact')
                  ? 'text-blue-600 border-b-2 border-blue-600 pb-1'
                  : 'text-gray-600 hover:text-blue-600'
              }`}
            >
              Liên hệ
            </Link>
          </nav>

          {/* Mobile menu button */}
          <button 
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
            onClick={toggleMobileMenu}
            aria-label="Toggle mobile menu"
          >
            {isMobileMenuOpen ? (
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="md:hidden absolute top-full left-0 right-0 bg-white shadow-lg border-t">
            <nav className="flex flex-col py-4">
              <Link
                to="/"
                className={`px-4 py-3 font-medium transition-colors border-l-4 ${
                  isActive('/')
                    ? 'text-blue-600 bg-blue-50 border-blue-600'
                    : 'text-gray-600 hover:text-blue-600 hover:bg-gray-50 border-transparent'
                }`}
                onClick={closeMobileMenu}
              >
                Trang chủ
              </Link>
              <Link
                to="/about"
                className={`px-4 py-3 font-medium transition-colors border-l-4 ${
                  isActive('/about')
                    ? 'text-blue-600 bg-blue-50 border-blue-600'
                    : 'text-gray-600 hover:text-blue-600 hover:bg-gray-50 border-transparent'
                }`}
                onClick={closeMobileMenu}
              >
                Giới thiệu
              </Link>
              <Link
                to="/test-mbti"
                className={`px-4 py-3 font-medium transition-colors border-l-4 ${
                  isActive('/test-mbti')
                    ? 'text-blue-600 bg-blue-50 border-blue-600'
                    : 'text-gray-600 hover:text-blue-600 hover:bg-gray-50 border-transparent'
                }`}
                onClick={closeMobileMenu}
              >
                Test MBTI
              </Link>
              <Link
                to="/test-iq"
                className={`px-4 py-3 font-medium transition-colors border-l-4 ${
                  isActive('/test-iq')
                    ? 'text-blue-600 bg-blue-50 border-blue-600'
                    : 'text-gray-600 hover:text-blue-600 hover:bg-gray-50 border-transparent'
                }`}
                onClick={closeMobileMenu}
              >
                Test IQ
              </Link>
              <Link
                to="/test-eq"
                className={`px-4 py-3 font-medium transition-colors border-l-4 ${
                  isActive('/test-eq')
                    ? 'text-blue-600 bg-blue-50 border-blue-600'
                    : 'text-gray-600 hover:text-blue-600 hover:bg-gray-50 border-transparent'
                }`}
                onClick={closeMobileMenu}
              >
                Test EQ
              </Link>
              <Link
                to="/test-disc"
                className={`px-4 py-3 font-medium transition-colors border-l-4 ${
                  isActive('/test-disc')
                    ? 'text-blue-600 bg-blue-50 border-blue-600'
                    : 'text-gray-600 hover:text-blue-600 hover:bg-gray-50 border-transparent'
                }`}
                onClick={closeMobileMenu}
              >
                Test DISC
              </Link>
              <Link
                to="/holland-codes"
                className={`px-4 py-3 font-medium transition-colors border-l-4 ${
                  isActive('/holland-codes')
                    ? 'text-blue-600 bg-blue-50 border-blue-600'
                    : 'text-gray-600 hover:text-blue-600 hover:bg-gray-50 border-transparent'
                }`}
                onClick={closeMobileMenu}
              >
                Holland Codes
              </Link>
              <Link
                to="/contact"
                className={`px-4 py-3 font-medium transition-colors border-l-4 ${
                  isActive('/contact')
                    ? 'text-blue-600 bg-blue-50 border-blue-600'
                    : 'text-gray-600 hover:text-blue-600 hover:bg-gray-50 border-transparent'
                }`}
                onClick={closeMobileMenu}
              >
                Liên hệ
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;